import { request } from '@/utils'

export default {
  getEmptyUser: () => {
    return {
      name: null,
    }
  },
  saveUser: (data: any) => request.post('/system/user/add', data),
  getAllRole: () => request.get('/system/system/open/getRole'),

  getUserList: (params: PageParams) =>
    request.post(`/hr/roster/employee/leavePageList?pageNumber=${params.pageNumber}&pageSize=${params.pageSize}`, params.body),
  getStatistics: () => request.post('/hr/roster/employee/leaveStatistics'),
  levelInfo: (userId: string | null) => request.post(`/hr/roster/employee/levelInfo?userId=${userId}`),
  doLevel: (data: any) => request.post('/hr/roster/employee/doLevel', data),
  confirmLevel: (data: any) => request.post('/hr/roster/employee/confirmLevel', data),
  cancelLeave: (userId: any) => request.post(`/hr/roster/employee/cancelLeave?userId=${userId}`, {}),
  getAllUser: () => request.post('/hr/roster/employee/getAllUser'),
  getAllUserWithLeave: () => request.post('/hr/roster/employee/getAllUserWithLeave'),
  transferWorkFlow: (data: any) => request.post('/hr/roster/employee/transferWorkFlow', data),
}
